// extracted by mini-css-extract-plugin
module.exports = {"link":"Item_link__2_a-X","icon":"Item_icon__1vLa8","infoIcon":"Item_infoIcon__3CAyA","centerCell":"Item_centerCell__2x7WI","cell":"Item_cell__Q-sFN"};